
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Material Design Css import
import { MatButtonModule, MatCheckboxModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
//Material Design Css import


import { AppComponent } from './khb.component';
import { HeaderComponent } from './common/header/header.component';
import { Level1menuComponent } from './common/level1menu/level1menu.component';
import { UltilitiesComponent } from './ultilities/ultilities.component';
import { UltilitiesMenuComponent } from './ultilities/ultilities-menu/ultilities-menu.component';
import { UserComponent } from './ultilities/user/user.component';
import { SearchbarComponent } from './common/searchbar/searchbar.component';
import { RolesComponent } from './ultilities/roles/roles.component';
import { RolesGridComponent } from './ultilities/roles/roles-grid/roles-grid.component';
import { RolesFormComponent } from './ultilities/roles/roles-form/roles-form.component';
import { UserService } from './shared/user.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './registration/login/login.component';
import { SignupComponent } from './registration/signup/signup.component';
import { UserGridComponent } from './ultilities/user/user-grid/user-grid.component';
import { UserFormComponent } from './ultilities/user/user-form/user-form.component';
import { ClaimGridComponent } from './ultilities/claims/claim-grid/claim-grid.component';
import { ClaimFormComponent } from './ultilities/claims/claim-form/claim-form.component';
import { ClaimsComponent } from './ultilities/claims/claims.component';
import { RegistrationComponent } from './registration/registration.component';
import { ErrorHandler } from './shared/ErrorHandler';
import { DataTablesModule } from 'angular-datatables';

import { NgxPaginationModule } from 'ngx-pagination';

import { appRoutes } from '../route';
import { HomepageComponent } from './homepage/homepage.component';
import { AuthGuard } from './auth/auth.guard';
import { ChangePasswordComponent } from './ultilities/change-password/change-password.component';
import { ForgotPasswordComponent } from './registration/forgot-password/forgot-password.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FooterComponent } from './common/footer/footer.component';
import { LeadComponent } from './Pages/lead/lead.component';
import { LeadFormComponent } from './Pages/Lead/lead-form/lead-form.component';
import { LeadGridComponent } from './Pages/Lead/lead-grid/lead-grid.component';
import { ActivityGridComponent } from './Pages/activities/activity-grid/activity-grid.component';
import { ActivityFormComponent } from './Pages/activities/activity-form/activity-form.component';
import { ActivitiesComponent } from './Pages/activities/activities.component';
import { ReportsComponent } from './Pages/reports/reports.component';
import { ReportFormComponent } from './Pages/reports/report-form/report-form.component';
import { ReportGridComponent } from './Pages/reports/report-grid/report-grid.component';
import { SalesOrderFormComponent } from './Pages/sales-orders/sales-order-form/sales-order-form.component';
import { SalesOrderGridComponent } from './Pages/sales-orders/sales-order-grid/sales-order-grid.component';
import { SalesOrdersComponent } from './Pages/sales-orders/sales-orders.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AssignLeadGridComponent } from './Pages/lead/assign-leads/assign-lead-grid/assign-lead-grid.component';
import { CompanyProfileGridComponent } from './ultilities/company-profile/company-profile-grid/company-profile-grid.component';
import { CompanyProfileFormComponent } from './ultilities/company-profile/company-profile-form/company-profile-form.component';
import { DivisionDeptFormComponent } from './ultilities/division-department/division-dept-form/division-dept-form.component';
import { DivisionDeptGridComponent } from './ultilities/division-department/division-dept-grid/division-dept-grid.component';
import { EmpMasterGridComponent } from './ultilities/employee-master/emp-master-grid/emp-master-grid.component';
import { EmpMasterFormComponent } from './ultilities/employee-master/emp-master-form/emp-master-form.component';
import { VenderFromComponent } from './Pages/manage/vender/vender-from/vender-from.component';
import { VenderGridComponent } from './Pages/Manage/vender/vender-grid/vender-grid.component';
import { ManageComponent } from './Pages/manage/manage.component';
import { SalseQuotationGridComponent } from './Pages/sales-orders/sales-quotation/salse-quotation-grid/salse-quotation-grid.component';
import { SalseQuotationFormComponent } from './Pages/sales-orders/sales-quotation/salse-quotation-form/salse-quotation-form.component';
import { PerformaInvoiceFormComponent } from './Pages/sales-orders/performa-invoice/performa-invoice-form/performa-invoice-form.component';
import { PerformaInvoiceGridComponent } from './Pages/sales-orders/performa-invoice/performa-invoice-grid/performa-invoice-grid.component';
import { SalesDeliveryChallanGridComponent } from './Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-grid/sales-delivery-challan-grid.component';
import { SalesDeliveryChallanFormComponent } from './Pages/sales-orders/sales-delivery-challan/sales-delivery-challan-form/sales-delivery-challan-form.component';
import { TaxInvoiceFormComponent } from './Pages/sales-orders/tax-invoice/tax-invoice-form/tax-invoice-form.component';
import { TaxInvoiceGridComponent } from './Pages/sales-orders/tax-invoice/tax-invoice-grid/tax-invoice-grid.component';
import { TaxInvoiceRetailGridComponent } from './Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-grid/tax-invoice-retail-grid.component';
import { TaxInvoiceRetailFormComponent } from './Pages/sales-orders/tax-invoice-retail/tax-invoice-retail-form/tax-invoice-retail-form.component';
import { ReceiptConfirmationGridComponent } from './Pages/sales-orders/receipt-confirmation/receipt-confirmation-grid/receipt-confirmation-grid.component';
import { ReceiptConfirmationFormComponent } from './Pages/sales-orders/receipt-confirmation/receipt-confirmation-form/receipt-confirmation-form.component';
import { PurchaseComponent } from './Pages/purchase/purchase.component';
import { PurchaseQuotationFormComponent } from './Pages/purchase/purchase-quotation/purchase-quotation-form/purchase-quotation-form.component';
import { PurchaseQuotationGridComponent } from './Pages/purchase/purchase-quotation/purchase-quotation-grid/purchase-quotation-grid.component';
import { QuotationComparisonGridComponent } from './Pages/purchase/quotation-comparison/quotation-comparison-grid/quotation-comparison-grid.component';
import { QuotationComparisonFormComponent } from './Pages/purchase/quotation-comparison/quotation-comparison-form/quotation-comparison-form.component';
import { QuotationApprovalFormComponent } from './Pages/purchase/quotation-approval/quotation-approval-form/quotation-approval-form.component';
import { QuotationApprovalGridComponent } from './Pages/purchase/quotation-approval/quotation-approval-grid/quotation-approval-grid.component';
import { PurchaseOrderGridComponent } from './Pages/purchase/purchase-order/purchase-order-grid/purchase-order-grid.component';
import { PurchaseOrderFormComponent } from './Pages/purchase/purchase-order/purchase-order-form/purchase-order-form.component';
import { QdChallanFormComponent } from './Pages/purchase/quotation-delivery-challan/qd-challan-form/qd-challan-form.component';
import { QdChallanGridComponent } from './Pages/purchase/quotation-delivery-challan/qd-challan-grid/qd-challan-grid.component';
import { MrNoteGridComponent } from './Pages/purchase/material-receipt-note/mr-note-grid/mr-note-grid.component';
import { MrNoteFormComponent } from './Pages/purchase/material-receipt-note/mr-note-form/mr-note-form.component';
import { MrnApprovalFormComponent } from './Pages/purchase/mrn-approval/mrn-approval-form/mrn-approval-form.component';
import { MrnApprovalGridComponent } from './Pages/purchase/mrn-approval/mrn-approval-grid/mrn-approval-grid.component';
import { ArPaymentGridComponent } from './Pages/purchase/account-receivable-payment/ar-payment-grid/ar-payment-grid.component';
import { ArPaymentFormComponent } from './Pages/purchase/account-receivable-payment/ar-payment-form/ar-payment-form.component';
import { ArReceiptGridComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-grid/ar-receipt-grid.component';
import { ArReceiptFormComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-form/ar-receipt-form.component';
import { PaymentApprovalFormComponent } from './Pages/purchase/payment-approval/payment-approval-form/payment-approval-form.component';
import { PaymentApprovalGridComponent } from './Pages/purchase/payment-approval/payment-approval-grid/payment-approval-grid.component';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ProfileComponent } from './Pages/user/profile/profile.component';
import { FeedbackComponent } from './Pages/User/feedback/feedback.component';
import { ArReceiptViewComponent } from './Pages/sales-orders/accounts-receivable-receipt/ar-receipt-view/ar-receipt-view.component';
import { DesignationComponent } from './Pages/manage/designation/designation.component';
import { DesignationGridComponent } from './Pages/manage/designation/designation-grid/designation-grid.component';
import { DesignationFormComponent } from './Pages/manage/designation/designation-form/designation-form.component';
import { QualificationComponent } from './Pages/manage/qualification/qualification.component';
import { QualificationgridComponent } from './Pages/manage/qualification/qualificationgrid/qualificationgrid.component';
import { QualificationformComponent } from './Pages/manage/qualification/qualificationform/qualificationform.component';
import { SpecilizationComponent } from './Pages/manage/specilization/specilization.component';
import { SpecilizationformComponent } from './Pages/manage/specilization/specilizationform/specilizationform.component';
import { SpecilizationgridComponent } from './Pages/manage/specilization/specilizationgrid/specilizationgrid.component';
import { DisciplineComponent } from './Pages/manage/discipline/discipline.component';
import { DisciplinegridComponent } from './Pages/manage/discipline/disciplinegrid/disciplinegrid.component';
import { DisciplineformComponent } from './Pages/manage/discipline/disciplineform/disciplineform.component';
import { HospitalComponent } from './Pages/manage/hospital/hospital.component';
import { HospitalformComponent } from './Pages/manage/hospital/hospitalform/hospitalform.component';
import { HospitalgridComponent } from './Pages/manage/hospital/hospitalgrid/hospitalgrid.component';
import { DistrictComponent } from './Pages/manage/district/district.component';
import { DistrictformComponent } from './Pages/manage/district/districtform/districtform.component';
import { DistrictgridComponent } from './Pages/manage/district/districtgrid/districtgrid.component';
import { StateComponent } from './Pages/manage/state/state.component';
import { StateformComponent } from './Pages/manage/state/stateform/stateform.component';
import { StategridComponent } from './Pages/manage/state/stategrid/stategrid.component';
import { NetworkComponent } from './Pages/manage/network/network.component';
import { NetworkgridComponent } from './Pages/manage/network/networkgrid/networkgrid.component';
import { NetworkformComponent } from './Pages/manage/network/networkform/networkform.component';
import { VendorComponent } from './Pages/manage/vendor/vendor.component';
import { VendorgridComponent } from './Pages/manage/vendor/vendorgrid/vendorgrid.component';
import { VendorformComponent } from './Pages/manage/vendor/vendorform/vendorform.component';
import { TasksComponent } from './Pages/tasks/tasks.component';
import { NewpatientComponent } from './Pages/tasks/newpatient/newpatient.component';
import { ExistingpatientComponent } from './Pages/tasks/existingpatient/existingpatient.component';
import { PatientstatusComponent } from './Pages/tasks/patientstatus/patientstatus.component';
import { ExistingpatientformComponent } from './Pages/tasks/existingpatient/existingpatientform/existingpatientform.component';
import { ExistingpatientgridComponent } from './Pages/tasks/existingpatient/existingpatientgrid/existingpatientgrid.component';
import { NewpatientformComponent } from './Pages/tasks/newpatient/newpatientform/newpatientform.component';
import { NewpatientgridComponent } from './Pages/tasks/newpatient/newpatientgrid/newpatientgrid.component';
import { PatientstatusformComponent } from './Pages/tasks/patientstatus/patientstatusform/patientstatusform.component';
import { PatientstatusgridComponent } from './Pages/tasks/patientstatus/patientstatusgrid/patientstatusgrid.component';
import { DoctorComponent } from './Pages/manage/doctor/doctor.component';
import { DoctorformComponent } from './Pages/manage/doctor/doctorform/doctorform.component';
import { DoctorgridComponent } from './Pages/manage/doctor/doctorgrid/doctorgrid.component';
import { AssistantComponent } from './Pages/manage/assistant/assistant.component';
import { AssistantformComponent } from './Pages/manage/assistant/assistantform/assistantform.component';
import { AssistantgridComponent } from './Pages/manage/assistant/assistantgrid/assistantgrid.component';
import { VleformComponent } from './Pages/manage/vle/vleform/vleform.component';
import { VlegridComponent } from './Pages/manage/vle/vlegrid/vlegrid.component';
import { VleComponent } from './Pages/manage/vle/vle.component';
import { HomeComponent } from './home/home.component';
// import { NavigationComponent } from './home/navigation/navigation.component';
// import { ServiceComponent } from './home/service/service.component';
// import { FootComponent } from './home/foot/foot.component';
import { ConsultancyComponent } from './Pages/tasks/consultancy/consultancy.component';
import { ConsultancyformComponent } from './Pages/tasks/consultancy/consultancyform/consultancyform.component';
import { ConsultancygridComponent } from './Pages/tasks/consultancy/consultancygrid/consultancygrid.component';
import { PharmacyLoginComponent } from './registration/pharmacy-login/pharmacy-login.component';
import { PatientLoginComponent } from './registration/patient-login/patient-login.component';
// import { PatientSignUpComponent } from './registration/patient-sign-up/patient-sign-up.component';
import { DoctorSignUpComponent } from './registration/doctor-sign-up/doctor-sign-up.component';
import { PharmasistSignUpComponent } from './registration/pharmasist-sign-up/pharmasist-sign-up.component';
import { DoctorLoginComponent } from './registration/doctor-login/doctor-login.component';
import { DiagnosticLoginComponent } from './registration/diagnostic-login/diagnostic-login.component';
import { SidenavComponentComponent } from './home/sidenav-component/sidenav-component.component';
import { DiagnosticSignupComponent } from './registration/diagnostic-login/diagnostic-signup/diagnostic-signup.component';
import { PatientProfileComponent } from './registration/patient-profile/patient-profile.component';

import { PatientViewGridComponent } from './Pages/tasks/patientprofile-view/patient-view-grid/patient-view-grid.component';
import { PatientViewFormComponent } from './Pages/tasks/patientprofile-view/patient-view-form/patient-view-form.component';
import { PatientprofileViewComponent } from './Pages/tasks/patientprofile-view/patientprofile-view.component';
import { BookAppointmentComponent } from './Pages/tasks/book-appointment/book-appointment.component';
import { BookAppointmentGridComponent } from './Pages/tasks/book-appointment/book-appointment-grid/book-appointment-grid.component';
import { BookAppointmentFormComponent } from './Pages/tasks/book-appointment/book-appointment-form/book-appointment-form.component';
import { PharmacyComponent } from './Pages/tasks/pharmacy/pharmacy.component';
import { PharmacyGridComponent } from './Pages/tasks/pharmacy/pharmacy-grid/pharmacy-grid.component';
import { DiagnosticTestComponent } from './Pages/tasks/diagnostic-test/diagnostic-test.component';
import { DiagnosticTestGridComponent } from './Pages/tasks/diagnostic-test/diagnostic-test-grid/diagnostic-test-grid.component';
import { ProductGridComponent } from './Pages/Manage/products/product-grid/product-grid.component';
import { ProductFormComponent } from './Pages/Manage/products/product-form/product-form.component';
import { ProductViewComponent } from './pages/manage/products/product-view/product-view.component';
import { FaqComponent } from './home/faq/faq.component';
// import { GalleryComponent } from './home/gallery/gallery.component';
import { AboutComponent } from './home/about/about.component';
import { SupportComponent } from './home/support/support.component';
import { Doctor1Component } from './home/doctor1/doctor1.component';
import { HospitalclinicComponent } from './home/hospitalclinic/hospitalclinic.component';
import { PatientSignUpComponent } from './registration/patient-sign-up/patient-sign-up.component';
import { NavigationComponent } from './home/navigation/navigation.component';
import { ServiceComponent } from './home/service/service.component';
import { FootComponent } from './home/foot/foot.component';
import { GalleryComponent } from './home/gallery/gallery.component';
import { QuicklinkComponent } from './home/quicklinks/quicklinks.component';
import { MyConsulationRequestFormComponent } from './Pages/tasks/MyConsulationRequest/MyConsulationRequest-form/MyConsulationRequest-form.component';
import { MyConsulationRequestComponent } from './Pages/tasks/MyConsulationRequest/MyConsulationRequest.component';
import { MyConsulationRequestGridComponent } from './Pages/tasks/MyConsulationRequest/MyConsulationRequest-grid/MyConsulationRequestgrid.component';
import { ContactUsComponent } from './home/ContactUs/ContactUs.component';
import { CareerComponent } from './home/career/career.component';

// import { MyComponent } from './tasks/my/my.component';
// import { PatientProfileViewComponent } from './tasks/patient-profile-view/patient-profile-view.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    Level1menuComponent,
    LoginComponent,
    UltilitiesComponent,
    UltilitiesMenuComponent,
    UserComponent,
    SearchbarComponent,
    RolesComponent,
    RolesGridComponent,
    RolesFormComponent,
    SignupComponent,
    UserGridComponent,
    UserFormComponent,
    ClaimGridComponent,
    ClaimFormComponent,
    ClaimsComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    HomepageComponent,
    ChangePasswordComponent,
    FooterComponent,
    LeadComponent,
    LeadFormComponent,
    LeadGridComponent,
    ActivityGridComponent,
    ActivityFormComponent,
    ActivitiesComponent,
    ReportsComponent,
    ReportFormComponent,
    ReportGridComponent,
    SalesOrderFormComponent,
    SalesOrderGridComponent,
    SalesOrdersComponent,
    AssignLeadGridComponent,
    CompanyProfileGridComponent,
    CompanyProfileFormComponent,
    DivisionDeptFormComponent,
    DivisionDeptGridComponent,
    EmpMasterGridComponent,
    EmpMasterFormComponent,
    VenderFromComponent,
    VenderGridComponent,
    ManageComponent,
    SalseQuotationGridComponent,
    SalseQuotationFormComponent,
    PerformaInvoiceFormComponent,
    PerformaInvoiceGridComponent,
    SalesDeliveryChallanGridComponent,
    SalesDeliveryChallanFormComponent,
    TaxInvoiceFormComponent,
    TaxInvoiceGridComponent,
    TaxInvoiceRetailGridComponent,
    TaxInvoiceRetailFormComponent,
    ReceiptConfirmationGridComponent,
    ReceiptConfirmationFormComponent,
    PurchaseComponent,
    PurchaseQuotationFormComponent,
    PurchaseQuotationGridComponent,
    QuotationComparisonGridComponent,
    QuotationComparisonFormComponent,
    QuotationApprovalFormComponent,
    QuotationApprovalGridComponent,
    PurchaseOrderGridComponent,
    PurchaseOrderFormComponent,
    QdChallanFormComponent,
    QdChallanGridComponent,
    MrNoteGridComponent,
    MrNoteFormComponent,
    MrnApprovalFormComponent,
    MrnApprovalGridComponent,
    ArPaymentGridComponent,
    ArPaymentFormComponent,
    ArReceiptGridComponent,
    ArReceiptFormComponent,
    PaymentApprovalFormComponent,
    PaymentApprovalGridComponent,
    ProfileComponent,
    FeedbackComponent,
    ArReceiptViewComponent,
    DesignationComponent,
    DesignationGridComponent,
    DesignationFormComponent,
    QualificationComponent,
    QualificationgridComponent,
    QualificationformComponent,
    SpecilizationComponent,
    SpecilizationformComponent,
    SpecilizationgridComponent,
    DisciplineComponent,
    DisciplinegridComponent,
    DisciplineformComponent,
    HospitalComponent,
    HospitalformComponent,
    HospitalgridComponent,
    DistrictComponent,
    DistrictformComponent,
    DistrictgridComponent,
    StateComponent,
    StateformComponent,
    StategridComponent,
    NetworkComponent,
    NetworkgridComponent,
    NetworkformComponent,
    VendorComponent,
    VendorgridComponent,
    VendorformComponent,
    TasksComponent,
    NewpatientComponent,
    ExistingpatientComponent,
    PatientstatusComponent,
    ExistingpatientformComponent,
    ExistingpatientgridComponent,
    NewpatientformComponent,
    NewpatientgridComponent,
    PatientstatusformComponent,
    PatientstatusgridComponent,
    DoctorComponent,
    DoctorformComponent,
    DoctorgridComponent,
    AssistantComponent,
    AssistantformComponent,
    AssistantgridComponent,
    VleformComponent,
    VlegridComponent,
    VleComponent,
    ConsultancyComponent,
    ConsultancyformComponent,
    ConsultancygridComponent,

    HomeComponent,
    NavigationComponent,
    ServiceComponent,
    FootComponent
,PharmacyLoginComponent
,PatientLoginComponent
,PatientSignUpComponent
,SignupComponent
,DoctorSignUpComponent
,PharmasistSignUpComponent
,DoctorLoginComponent
,DiagnosticLoginComponent
,SidenavComponentComponent,
PatientprofileViewComponent 
,DiagnosticSignupComponent, PatientProfileComponent, PatientViewGridComponent, PatientViewFormComponent, 
// MyComponent, PatientProfileViewComponent
BookAppointmentComponent,
BookAppointmentGridComponent,
BookAppointmentFormComponent,
PharmacyComponent,
PharmacyGridComponent,
DiagnosticTestComponent,
DiagnosticTestGridComponent,
ProductGridComponent,
ProductFormComponent,
ProductViewComponent,
FaqComponent,
GalleryComponent,
AboutComponent,
SupportComponent,
Doctor1Component,
HospitalclinicComponent,
QuicklinkComponent ,
MyConsulationRequestFormComponent,
MyConsulationRequestGridComponent,
MyConsulationRequestComponent,
ContactUsComponent,
CareerComponent



  ],
  imports: [
    BsDropdownModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    //mat
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
 
    //end  
    
    //new kishore

 

    DataTablesModule,    
    NgxPaginationModule,
    FormsModule,
    ReactiveFormsModule,
    
    HttpClientModule,
    RouterModule.forRoot(appRoutes),
  ],
  providers: [UserService, ErrorHandler, AuthGuard, { provide: LocationStrategy, useClass: HashLocationStrategy },

  ],
  bootstrap: [AppComponent]
})
export class AppModule { } 



// WEBPACK FOOTER //
// ./src/app/khb.module.ts